export default __webpack_public_path__ + "static/photo7usluge-c2455e36e4c13772e6c6f332bfa06b5c.png";